export default __webpack_public_path__ + "static/media/2_0158.b64d381d.webp";